import { apiFetch } from "core/api/base";

export function * postPlaygroundExec ({ namespace, playgroundId, environment, model }) {
	return yield apiFetch({
		endpoint: `/v1/playground/exec`,
		method: "POST",
		authenticated: true,
		body: JSON.stringify(model)
	});
}

// Updated to use the v2 dispatcher action getRunInfo
export function * getPlaygroundExecByRunId ({ namespace, playgroundId, runId, verbose }) {
	// verbose is no longer used by the backend for this action
	const r = yield apiFetch({
		// IMPORTANT: Do NOT prefix with /api here because environment.api may already include '/api'
		endpoint: `/v2/playground`,
		method: "POST",
		authenticated: true,
		body: JSON.stringify({ action: "getRunInfo", runId: runId })
	});

	// Unwrap the dispatch envelope { ok, data } to keep existing callers working with the data directly
	if (r && r.json && typeof r.json === "object" && r.json !== null && Object.prototype.hasOwnProperty.call(r.json, "ok")) {
		return { json: r.json.ok ? r.json.data : null, response: r.response };
	}

	return r;
}

export function * getPlaygroundExecByCorrelationId ({ namespace, playgroundId, correlationId, verbose }) {
	const verboseStr = (verbose) ? "true" : "false";

	return yield apiFetch({
		endpoint: `/v1/playground/${namespace}/${playgroundId}/exec/correlation/${correlationId}?verbose=${verboseStr}`,
		method: "GET",
		authenticated: true
	});
}

export function * getPlaygroundExecQuery ({
	namespace, playgroundId, env, versionId, jobId,
	correlationId, status, dataSourceTypes
}) {
	return yield apiFetch({
		endpoint: `/v1/playground/${namespace}/${playgroundId}/exec/query`,
		method: "GET",
		authenticated: true,
		params: {
			env: env || "",
			version_id: versionId || "",
			job_id: jobId || "",
			correlation_id: correlationId || "",
			status: status || "",
			data_source_types: dataSourceTypes || ""
		}
	});
}
